import React from 'react'
import dayjs from 'dayjs'
import { createRoot } from 'react-dom/client'

import reportWebVitals from '@app/reportWebVitals'

import App from '@app/App'
import { RootProvider } from '@app/providers'

import 'dayjs/locale/ru'

import '@app/sprite.ts'
import '@app/styles/styles.scss'

dayjs.locale('ru')

const container = document.getElementById('root') as HTMLElement

const root = createRoot(container)

const app = (
  <RootProvider>
    <App />
  </RootProvider>
)

root.render(app)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
